module.exports = __webpack_public_path__ + "staticesp/media/gif-dimen1.c13e454f.gif";